import script from "./PlayerExportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerExportDialog.vue?vue&type=script&setup=true&lang=js"

import "./PlayerExportDialog.vue?vue&type=style&index=0&id=4a480cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a480cba"]])

export default __exports__